import React from 'react';

import classNames from 'classnames';
import { faStop } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'components/ui/button';
import LoadingSpinner from 'components/ui/loading_spinner';
import SanitizedHTML from 'components/ui/sanitized_html';

import SparkBadge from './spark_badge';
import { AI_HTML_OPTIONS } from 'components/ai/html';
import { formatMetrics } from './metrics/helpers';

import type { Message } from './types';

interface Props {
  message: Message;
  showAdminDetails: boolean;
  showStopSpeaking: boolean;
  onStopSpeaking: () => void;
}

export default function AssistantMessage({ message, showAdminDetails, showStopSpeaking, onStopSpeaking }: Props) {
  return (
    <div className="d-flex gap-2 mb-3">
      <SparkBadge className="flex-shrink-0 align-self-start" />
      <div className={classNames({ 'text-danger': message.error })} style={{ maxWidth: '85%' }}>
        {message.content && (
          <SanitizedHTML
            className={classNames('ai-assistant-prose', {
              'is-streaming': message.isStreaming && !message.status,
            })}
            html={message.content}
            {...AI_HTML_OPTIONS}
          />
        )}
        {message.isStreaming && (message.status || !message.content) && (
          <div className="d-flex align-items-center gap-2 text-muted small mt-1">
            <LoadingSpinner inline size="sm" />
            <span className="fst-italic">{message.status || 'Thinking'}…</span>
          </div>
        )}
        {showStopSpeaking && (
          <Button
            aria-label="Stop speaking"
            className="text-danger mt-1"
            icon={faStop}
            size="sm"
            variant="ghost"
            onClick={onStopSpeaking}
          />
        )}
        {showAdminDetails && message.metrics && (
          <div className="text-muted small mt-1">{formatMetrics(message.metrics)}</div>
        )}
      </div>
    </div>
  );
}
